module.exports = __webpack_public_path__ + "img/cross.15c51817.svg";